import HeaderComponent, { HeaderProps } from './Header.component';

const HeaderContainer = function (props: HeaderProps): JSX.Element {
  return <HeaderComponent {...props} />;
};

export default HeaderContainer;
